import { render, staticRenderFns } from "./TotalRow.vue?vue&type=template&id=459aae40"
import script from "./TotalRow.vue?vue&type=script&lang=js"
export * from "./TotalRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports